// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./retailers.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");

// event handler
var nunt = require("lib/nunt");
var dropdown = require("../dropdown/dropdown");
var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).retailers;
var parsing = require('parsing').retailers;

var dataSource = "";
var moduleData = false;
var specialCharsRegex = /[\.\!\#\$\^\%\;\,\/\|\?\'\-]/gim;

function escapeCharToEntityNumber(match){
    return '&#'+match.charCodeAt(0)+';';
}

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
}

function setCookie(name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '')  + expires + '; path=/';
}

function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function parse(text, next) {
    strip(require('raw!./retailers.html'), function(outputHtml) {
        // if the text after ":" isnt pc,van,smart or truck it is considered to be one or many id
        var match = parsing.parse(text);

        var options;

        if (match) {
            var that = this;

            var requireData = "dealers";

            // This is the cookie we read and use, but its not set by us.
            var groupDealer = getParameterByName('dealer');
            if (groupDealer) {
                setCookie('dealer-cookie', groupDealer);
            } else {
                groupDealer = getCookie('dealer-cookie');
            }

            if (groupDealer) {

                // This handles when a visitor has a cookie with a group name, so it can filter
                // the retailers by that specific group
                requireData += "/bygroup/" + groupDealer;

            } else {

                if (match[5]) {
                    requireData += "/byid/" + match[5];
                }
                else if (match[1]) {
                    requireData += "/" + match[1];
                }

            }

            getData(requireData, function (jsonString) {
                // check if the datasource is to be overridden
                if (that.dataSource && that.dataSource != "") {
                    jsonString = that.dataSource;
                }

                try {
                    if (typeof jsonString == "object") {
                        options = jsonString;
                    }
                    else {
                        options = JSON.parse(jsonString);
                    }
                }
                catch (e) {
                    options = false;
                }

                moduleData = options;

                var insertOptions = "";
                if (options) {
                    var array = [];
                    for (var i = 0; i < options.length; i++) {
                        var name = options[i].name.replace(specialCharsRegex, escapeCharToEntityNumber);
                        var city = options[i].city.replace(specialCharsRegex, escapeCharToEntityNumber);

                        var label = (options[i].label) ? options[i].label : city + ': ' + name;
                        var value = (options[i].value) ? options[i].value : options[i].outletcodeMb;

                        array[i] = value + " -> " + label;

                        if (options[i].selected) {
                            array[i] = "(" + array[i] + ")";
                        }
                    }
                    insertOptions = array.join(",");
                }

                var container = document.createElement("div");
                container.innerHTML = outputHtml;
                var domObj = container.firstChild;

                insertOptions = 'null -> ' + domObj.getAttribute('data-default-label').replace('{{', '').replace('}}', '') + ',' + insertOptions;

                outputHtml = outputHtml.replace("{}", "{" + insertOptions + "}");

                if (match[6] == "*") {
                    container.innerHTML = outputHtml;
                    domObj = container.firstChild;

                    // add a "required" class to the parent node
                    domObj.setAttribute("class", domObj.getAttribute("class") + " required");
                    domObj.setAttribute("data-required", "true");

                    outputHtml = container.innerHTML.replace("= {", "* = {");
                }

                text = text.replace(match[0], outputHtml);
                next(text);
            });
        }
        else {
            next(text);
        }
    });
};

function validate(context, err) {
    var value = get(context);
    var required = context.getAttribute("data-required") == "true";
    var input = context.querySelector("select");

    var currentClasses = input.getAttribute("class") || "";
    currentClasses = currentClasses.replace(/(|\s)valid(|\s)/g, "").replace(/(|\s)error(|\s)/g, "");

    var messagelabel = context.querySelector("#txt_retailers-error");
    messagelabel.innerHTML = "";

    return validation.validate(value, required)
        .then(function(validationResult) {
            validationResult = !err ? validationResult : err;
            dropdown.validate(context);

            if (!validationResult.valid) {
                input.setAttribute("class", currentClasses + " error");
                var message = document.createTextNode(context.getAttribute("data-msg-required"));
                messagelabel.appendChild(message);
                messagelabel.setAttribute("class", " error");
            }
            else {
                input.setAttribute("class", currentClasses + " valid");
                var message = document.createTextNode(context.getAttribute("data-msg-valid"));
                messagelabel.appendChild(message);
                messagelabel.setAttribute("class", " valid");
            }

            return validationResult.valid;
        });
}

function get(context) {
    var value = dropdown.get(context);

    return value;
}

function reset(context) {
    dropdown.reset(context);
}

function data(value) {

    var res = moduleData;

    if( value && moduleData ) {
        for( var i = 0, ii = moduleData.length; i < ii; i++ ) {
            if( moduleData[i].value ) {
                if( value == moduleData[i].value ) {
                    res = moduleData[i];
                    break;
                }
            }
            else if( moduleData[i].outletcodeMb ) {
                if( value == moduleData[i].outletcodeMb ) {
                    res = moduleData[i];
                    break;
                }
            }
        }
    }

    return res;
}

module.exports = {
    parse: parse,
    validate: validate,
    dataSource: dataSource,
    get: get,
    data: data,
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/retailers/retailers.js